export const TASK_STATUS = [
  { v: "bekliyor", label: "Bekliyor", cls: "bg-[color:var(--warning-bg)] text-[color:var(--warning)]" },
  { v: "devam", label: "Devam Ediyor", cls: "bg-[color:var(--accent-bg)] text-[color:var(--accent)]" },
  { v: "tamamlandi", label: "Tamamlandı", cls: "bg-[color:var(--success-bg)] text-[color:var(--success)]" },
];

export const statusMeta = (v) => TASK_STATUS.find((s) => s.v === v) || TASK_STATUS[0];

export const isOverdue = (t) => {
  if (!t.due_date || t.status === "tamamlandi") return false;
  return t.due_date < new Date().toISOString().slice(0, 10);
};

export const formatDue = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString("tr-TR") : "—");
